import { apiUrl1, apiUrl2, apiUrl4 } from "../configs/constant";
import CryptoJS from 'crypto-js';
import { generateRandomKey } from "./format-data";
const password = process.env.REACT_APP_PASSWORD;

export const sendMaraTx = async (hex) => {
  const url = `https://slipstream.mara.com/rest-api/submit-tx`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      tx_hex: hex
    }),
  })

  return await response.json();
}

export const getMaraInfo = async () => {
  const url = `${apiUrl4}/op20/feerate`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return await response.json();
}

export const getOp20DomainCheck = async (domain) => {
  const url = `${apiUrl4}/op20/domain/check?domain=${domain}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20DomainIndex = async (value, type, offset, limit) => {
  const url = `${apiUrl4}/op20/domain/index?value=${value}&type=${type}&offset=${offset}&limit=${limit}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20DomainHolders = async (value, page, limit) => {
  const url = `${apiUrl4}/op20/domain/holders?value=${value}&offset=${page}&limit=${limit}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20HotDomainCount = async (type) => {
  const url = `${apiUrl4}/op20/domain/hotMintedCount?type=${type}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20HotDomainList = async (type, data) => {
  const url = `${apiUrl4}/op20/domain/hotMintedList`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type, data
    }),
  })

  return await response.json();
}

export const getOp20DomainAddress = async (type, address, offset, limit) => {
  const url = `${apiUrl4}/op20/domain/address?type=${type}&address=${address}&offset=${offset}&limit=${limit}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20UtxosForTransfer = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosOp20Transfer`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getOp20UtxosForUtxoTransfer = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosOp20UtxoTransfer`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getOp20UtxosForUtxoSplit = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosOp20UtxoSplit`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getOp20PSBTForSale = async (data) => {
  const url = `${apiUrl1}/op20/generatePsbtForSale`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getOp20PSBTForBuy = async (data) => {
  const url = `${apiUrl1}/op20/generatePsbtForBuy`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const op20BroadcastTransaction = async (data) => {
  const url = `${apiUrl1}/op20/broadcastTransaction`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const splitPsbt = async (data) => {
  const url = `${apiUrl1}/op20/splitPsbt`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const saveOp20TradeData = async (data) => {
  const url = `${apiUrl2}/op20/trade/register`;
  data.randomKey = generateRandomKey(16);
  data.randomKeyHash = CryptoJS.AES.encrypt(data.randomKey, password).toString();

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const saveOp20TradeDataForDomain = async (data) => {
  const url = `${apiUrl2}/op20/trade/register/domain`;
  data.randomKey = generateRandomKey(16);
  data.randomKeyHash = CryptoJS.AES.encrypt(data.randomKey, password).toString();

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getTradeActivity = async (ticker, mode, page, limit) => {
  const url = `${apiUrl4}/op20/trade/activity?ticker=${ticker}&mode=${mode}&page=${page}&limit=${limit}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getTradeActivityForDomain = async (domainMode, mode, page, limit) => {
  const url = `${apiUrl4}/op20/trade/activity/domain?domainMode=${domainMode}&mode=${mode}&page=${page}&limit=${limit}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20TradeCheck = async (id) => {
  const url = `${apiUrl4}/op20/trade/check?id=${id}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20Trade = async (page, limit, ticker, order, direction, duration) => {
  const url = `${apiUrl4}/op20/trade?page=${page}&limit=${limit}&query=${ticker}&order=${order}&direction=${direction}&duration=${duration}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20TradeByTicker = async (ticker, duration) => {
  const url = `${apiUrl4}/op20/tradeByTicker?query=${ticker}&duration=${duration}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const createTradeHistory = async (ticker) => {
  const url = `${apiUrl4}/op20/trade/create?ticker=${ticker}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20TradeList = async (page, limit, ticker, order, direction) => {
  const url = `${apiUrl4}/op20/trade/list?page=${page}&limit=${limit}&ticker=${ticker}&order=${order}&direction=${direction}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20TradeListForDomain = async (page, limit, mode, order, direction, domain) => {
  const url = `${apiUrl4}/op20/trade/list/domain?page=${page}&limit=${limit}&mode=${mode}&order=${order}&direction=${direction}&domain=${domain}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20TradeListByAddress = async (ticker, address) => {
  const url = `${apiUrl4}/op20/trade/list/address?address=${address}&ticker=${ticker}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20TradeListByAddressForDomain = async (mode, address, domain, page, limit) => {
  const url = `${apiUrl4}/op20/trade/list/address/domain?address=${address}&mode=${mode}&domain=${domain}&page=${page}&limit=${limit}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20BalanceTicker = async (address, ticker) => {
  const url = `${apiUrl4}/op20/balance/ticker?address=${address}&ticker=${ticker}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}


export const getOp20InscribeUtxos = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosOp20`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getPaymentUtxosOp20Inscribe = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosOp20Inscribe`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getPaymentUtxosOp20InscribeBulk = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosOp20InscribeBulk`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getPaymentUtxosOp20NameBulkMint = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosOp20NameBulkMint`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}


export const getOp20InscribeUtxosBulk = async (data) => {
  
  const url = `${apiUrl1}/getPaymentUtxosOp20Bulk`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getOp20TransactionUtxo = async (data) => {
  const url = `${apiUrl4}/op20/payment/funded`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getOp20TransactionUtxoForDomain = async (data) => {
  const url = `${apiUrl4}/op20/payment/fundedForDomain`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getOp20Balance = async (address, offset, limit = 12) => {
  const url = `${apiUrl4}/op20/balance?address=${address}&limit=${limit}&offset=${offset}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20DomainNameForMode = async (address, mode, type) => {
  const url = `${apiUrl4}/op20/domain/address/mode?address=${address}&mode=${mode}&type=${type}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20Indexer = async (tick, offset, limit, orderBy, orderDir) => {
  const url = `${apiUrl4}/op20/indexer?tick=${tick}&limit=${limit}&offset=${offset}&orderBy=${orderBy}&orderDir=${orderDir}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20IndexerTicker = async (tick, offset, limit = 12) => {
  const url = `${apiUrl4}/op20/indexer/tick?tick=${tick}&limit=${limit}&offset=${offset}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20CheckTicker = async (tick) => {
  const url = `${apiUrl4}/op20/checkTicker?tick=${tick}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getOp20TickerDetail = async (tick) => {
  const url = `${apiUrl4}/op20/detail/ticker?tick=${tick}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}
